
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/tnpsc-coimbatore",
      function () {
        return require("private-next-pages/tnpsc-coimbatore/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/tnpsc-coimbatore"])
      });
    }
  